import styled from 'styled-components'
import Text from '../../general/Typography/Text/Text'
import Breadcrumb from '../../navigation/Breadcrumb/Breadcrumb'
import { useUiKitContext } from '../../utils/UiKitProvider/UiKitProvider'
import BackButton from '../../general/Button/predefined/BackButton'
import { theme } from '../../config/theme'
import { Card } from '../../layout'
import { Link } from 'react-router-dom'

export type BasicPageHeaderProps = {
  title?: React.ReactNode
  subtitle?: string
  children?: React.ReactNode
  onBack?: () => void
  backButtonHref?: string
  breadcrumbItems?: JSX.Element[]
  className?: string
  onBackTitle?: string
  testId?: string
}

const BasicPageHeader = (props: BasicPageHeaderProps) => {
  const {
    title,
    subtitle,
    children,
    breadcrumbItems,
    onBack,
    backButtonHref,
    className,
    onBackTitle,
    testId
  } = props
  const { translation: t } = useUiKitContext()
  const shouldRenderBackButton = onBack || backButtonHref

  const renderBackButton = (
    <BackButton onClick={onBack} data-testid={`${testId}-back-button`}>
      {onBackTitle || t('general.buttons.back')}
    </BackButton>
  )

  return (
    <Wrapper data-testid={testId}>
      <Content className={className}>
        <div>
          {breadcrumbItems && breadcrumbItems.length > 0 && (
            <BreadcrumbStyled>
              {breadcrumbItems.map((item, index) => {
                if (!item.key) {
                  throw new Error(
                    `A breadcrumb item does not have a key prop. Please provide one. Index: ${index}, Item: ${item}`
                  )
                }

                return <Breadcrumb.Item key={item.key}>{item}</Breadcrumb.Item>
              })}
            </BreadcrumbStyled>
          )}
          {shouldRenderBackButton && backButtonHref && (
            <Link to={backButtonHref}>{renderBackButton}</Link>
          )}
          {shouldRenderBackButton && !backButtonHref && renderBackButton}
          <TitleWrapper>{title}</TitleWrapper>
          <TextStyled>{subtitle}</TextStyled>
        </div>
        {children}
      </Content>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.color.neutral.color9};
`

const Content = styled(Card)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: ${(props) => props.theme.properties.borderRadius.large};
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    flex-direction: column;
    gap: 16px;
  }
`

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`
const TextStyled = styled(Text)`
  display: block;

  opacity: 0.7;
  color: ${theme.color.neutral.color3};
` as typeof Text

const BreadcrumbStyled = styled(Breadcrumb)`
  margin-bottom: 4px;
`

export default BasicPageHeader
